import { call, put, select } from "redux-saga/effects";

import { DELETE_SCHOOL } from "../../../../constants/SchoolConstants";
import { FAILURE } from "../../../../constants/BaseConstants";
import { SCHOOLS_PATH } from "../../../../constants/RoutesConstants";
import deleteSchoolCall from "../../../../api/SchoolCalls/deleteSchoolCall";
import getSchoolIdSelector from "../../../selectors/SchoolSelectors/getSchoolIdSelector";
import { replace } from "connected-react-router";

export default function* deleteSchoolSaga(): any {
    try {
        const id = yield select(getSchoolIdSelector);
        yield call(deleteSchoolCall, id);
        yield put(replace(SCHOOLS_PATH));
    } catch (error) {
        yield put({ type: DELETE_SCHOOL + FAILURE, error });
    }
}
